export default {"src":"/uk/_next/static/media/emailYellowIcon.f9596247.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};